import React from "react"; // Make sure to add this line
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "boxicons";
import "./assets/css/responsive.css";
import Login from "./app/screens/Login";
import Dashboard from "./app/screens/Dashboard";
// import SpeechStudy from "./app/screens/researchData/speechStudy/Main";
// import RadcliffStudy from "./app/screens/researchData/radcliffStudy/Main";
import Ecas from "./app/screens/researchData/ecas/Main";
import SlpSubStudy from "./app/screens/researchData/slpSubStudy/Main";
import SpeechParticipants from "./app/screens/researchData/participants/speech/List";
import RadcliffParticipants from "./app/screens/researchData/participants/radcliff/List";
import Details from "./app/screens/researchData/participants/Details";
import ViewLogsDetails from "./app/screens/researchData/participants/ViewLogsDetails";
import ChangePassword from "./app/screens/ChangePassword";
import ContentLibrary from "./app/screens/ContentLibrary";
import FeatureRoadMap from "./app/screens/featureRoadmap/List";
import FeatureRoadMapAdd from "./app/screens/featureRoadmap/Add";
import ConsortiaKnowledgebase from "./app/screens/ConsortiaKnowledgebase";
import EcasList from "./app/screens/researchData/ecas/List";
import ViewEcas from "./app/screens/researchData/ecas/View";
import ViewDemographics from "./app/screens/researchData/participants/radcliff/ViewDemographics";
import EventCalendar from "./app/screens/EventCalendar";
import SpeechDemographics from "./app/screens/SpeechDemographics";
import ConsortiaUploadList from "./app/screens/consortiaUploads/List";
import ConsortiaUploadAdd from "./app/screens/consortiaUploads/Add";
import ConsortiaUploadEdit from "./app/screens/consortiaUploads/Edit";


// forgot password
import ForgotPassword from "./app/screens/forgotPassword/ForgotPassword";
import VerifyOtp from "./app/screens/forgotPassword/VerifyOtp";
import ResetPassword from "./app/screens/forgotPassword/ResetPassword";
import ParticipantStatus from "./app/screens/researchData/participants/ParticipantStatus";
import Reports from "./app/screens/myStudies/Reports";
import Resources from "./app/screens/myStudies/Resources";
//import mystudiesdashboard in next line
import MyStudiesDashboard from"./app/screens/myStudies/MyStudiesDashboard";
import OtherDataSources from "./app/screens/OtherDataSources";

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/mystudies/dashboard" element={<MyStudiesDashboard />} />
          <Route path="/mystudies/reports" element={<Reports />} />
          <Route path="/mystudies/resources" element={<Resources />} />
          {/* <Route path="/speech-study" element={<SpeechStudy />} /> */}
          {/* <Route path="/radcliff-study" element={<RadcliffStudy />} /> */}
          <Route path="/ecas" element={<Ecas />} />
          <Route path="/ecas/list" element={<EcasList />} />
          <Route path="/ecas-view" element={<ViewEcas />} />
          <Route path="/slp-substudy" element={<SlpSubStudy />} />
          <Route path="/other-data-sources" element={<OtherDataSources />} />
          <Route path="/content-library" element={<ContentLibrary />} />
          <Route path="/consortia-requests" element={<FeatureRoadMap />} />
          <Route
            path="/consortia-requests/add"
            element={<FeatureRoadMapAdd />}
          />
          <Route
            path="/consortia-workspace"
            element={<ConsortiaKnowledgebase />}
          />
          <Route path="/participants/speech" element={<SpeechParticipants />} />
          <Route
            path="/participants/radcliff"
            element={<RadcliffParticipants />}  
          />
          {/* <Route
            path="/participant/view-demographics"
            exact
            element={<ViewDemographics />}
          /> */}
          <Route
            path="/participant-status"
            element={<ParticipantStatus />}
            
          />
                    <Route path="/other-data-sources" element={<OtherDataSources />} />


          {/* <Route path="/view-demographics" exact element={<Details />} /> */}
          <Route path="/ViewLogsDetails" element={<ViewLogsDetails />} />
          <Route path="/change_password" element={<ChangePassword />} />
          <Route path="/events-calendar" element={<EventCalendar />} />
          <Route
            path="/speech-demographics-report"
            element={<SpeechDemographics />}
          />
          <Route path="/consortia-uploads" element={<ConsortiaUploadList />} />
          <Route
            path="/consortia-upload/add"
            element={<ConsortiaUploadAdd />}
          />
          <Route
            path="/consortia-upload/edit"
            element={<ConsortiaUploadEdit />}
          />
          <Route path="/forgot-password" exact element={<ForgotPassword />} />
          <Route path="/verify-otp" exact element={<VerifyOtp />} />
          <Route path="/reset-password" exact element={<ResetPassword />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
